import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { SouvenirsModel } from './SouvenirsModel';

@Injectable({
  providedIn: 'root'
})
export class SouvenirsService {

  
  constructor(private http: HttpClient ) { }
  baseUrl = environment.baseApiUrl;
  token = localStorage.getItem("token");
  httpOptions = {
   headers: new HttpHeaders({
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
   })
 };

 getAll(): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Souvenirs/GetAll`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}


getById(Id:number): Observable<any> {

  return this.http
    .get<any>(`${this.baseUrl}Souvenirs/GetById/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

getAllByCountryId(CountryId:number): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Souvenirs/GetAllByCountryId/${CountryId}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}


}
